import { create } from 'zustand'
import {
  PermissionScopeT,
  ProjectRolesT, SingleProjectRoleT,
} from '@/routes/settings/projectRoles/lib/types/projectRolesTypes.ts'
import { IssueTypesMembers } from '@/routes/settings/issueTypes/types/issueType.ts'

type ProjectRolesStoreT = {
  roleId: string | null
  setRoleId: (roleId: string | null) => void
  selectedRole: SingleProjectRoleT | null
  setSelectedRole: (selectedRole: SingleProjectRoleT | null) => void
  projectRoles: ProjectRolesT | null
  setProjectRoles: (projectRoles: ProjectRolesT | null) => void
  dialogOpened: boolean
  setDialogOpened: (state: boolean) => void
  selectedPermissionsScope: PermissionScopeT
  setSelectedPermissionsScope: (selectedPermissionsScope: PermissionScopeT) => void
  issueTypes: IssueTypesMembers | null
  setIssueTypes: (issueTypes: IssueTypesMembers | null) => void
}

export const useProjectRolesStore = create<ProjectRolesStoreT>(set => ({
  roleId: null,
  setRoleId: roleId => set({ roleId }),
  selectedRole: null,
  setSelectedRole: selectedRole => set({ selectedRole }),
  projectRoles: null,
  setProjectRoles: projectRoles => set({ projectRoles }),
  issueTypes: [],
  setIssueTypes: issueTypes => set({ issueTypes }),
  dialogOpened: false,
  setDialogOpened: dialogOpened =>
    set({
      dialogOpened: dialogOpened,
      selectedPermissionsScope: `CREATE`,
    }),

  selectedPermissionsScope: `CREATE`,
  setSelectedPermissionsScope: (selectedPermissionsScope: PermissionScopeT) =>
    set({ selectedPermissionsScope }),
}))
